module.exports = __webpack_public_path__ + "static/media/feature_lobster.021c0983.jpg";